/* global axios */
import ApiClient from './ApiClient';

class CampaignPlansAPI extends ApiClient {
  constructor() {
    super('campaign_plans', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(campaignPlanObj) {
    return axios.post(this.url, campaignPlanObj);
  }

  delete(campaignPlanId) {
    return axios.delete(`${this.url}/${campaignPlanId}`);
  }
}

export default new CampaignPlansAPI();

